import { StepData } from "../components/FormViewer/FormViewer.types";
import { createContext } from 'react';

export const AppContext = createContext<IAppContext>({
  steps: [],
  settings: {},
  activeStepIndex: 0,
  prevStepIndex: 0,
  disableButton: false,
  breadcrumb: [],
  updateBreadcrumb: () => Function(),
  updateActiveStepIndex: () => Function(),
  updateDisableButton: () => Function(),
  handleStepTransition: () => Function(),
  handleStepSubmit: () => Promise.resolve(),
  handleBackClick: () => Function(),
  updateErrorMessage: () => Function(),
  updatePrevStepIndex: () => Function(),
});

export interface IAppContext {
  steps: any,
  settings: any,
  activeStepIndex: number,
  prevStepIndex: number,
  disableButton: boolean,
  breadcrumb: number[],
  updateBreadcrumb: (indexOrArray: number | number[]) => void,
  updateActiveStepIndex: (index: number) => void,
  updateDisableButton: (disableButton: boolean) => void,
  handleStepTransition: (steps: any, stepData: StepData) => void,
  handleStepSubmit: (context: IAppContext, stepData: StepData) => Promise<void>,
  handleBackClick: (context: IAppContext) => void,
  updateErrorMessage: (errorMessage: string | boolean) => void,
  updatePrevStepIndex: (index: number) => void,
}

